<!--
 * @Author: chenx
 * @CreatedDate: Do not edit
 * @LastEditTime: 2021-04-06 18:20:17
 * @Description: IM聊天
-->
<template>
  <div v-if="imAccount">
    <zjkj-im
      :key="random"
      v-show="showImChat"
      :imAccount="imAccount"
      :imToken="imToken"
      @close="closeIm"
      ref="zjkjImRef"
    ></zjkj-im>
  </div>
</template>
<script>
import { mapState } from "vuex"
import eventBus from "@/utils/event-bus"

import Vue from "vue";
import chatIm from 'vue-chat-im'
import router from '@/router/index.js'
import store from '@/store'
chatIm.mergeStore(store, router) //vuex 注册im模块
Vue.use(chatIm)

export default {
  data() {
    return {}
  },
  computed: {
    random() {
      return this.$store.state.random;
    },
    imAccount() {
      return this.$store.state.user && this.$store.state.user.imAccount
        ? this.$store.state.user.imAccount
        : '';
    },
    imToken() {
      return this.$store.state.user && this.$store.state.user.imToken
        ? this.$store.state.user.imToken
        : '';
    },
    showImChat() {
      return this.$store.state.showImChat;
    },
  },
  // computed: {
  //   ...mapState({
  //     random: state => state.random,
  //     imAccount: state => state.user.imAccount,
  //     imToken: state => state.user.imToken,
  //     showImChat: state => state.showImChat,
  //     chatImToken:state => state.token,
  //   })
  // },
  mounted() {
    eventBus.$on("sendImMessage", imAccount => {
      this.$store.commit("setChatStatus", true)
      this.$nextTick(() => {
        this.$refs.zjkjImRef.findFriend(imAccount)
      })
    })
  },
  methods: {
    closeIm() {
      this.$store.commit("setChatStatus", false)
    }
  }
}
</script>
